import icon1 from "../assets/images/icons/icon1.svg";
import icon2 from "../assets/images/icons/icon2.svg";
import icon3 from "../assets/images/icons/icon3.svg";
import icon4 from "../assets/images/icons/icon4.svg";
import icon5 from "../assets/images/icons/icon5.svg";
import icon6 from "../assets/images/icons/icon6.svg";
import icon7 from "../assets/images/icons/icon7.svg";
import icon8 from "../assets/images/icons/icon8.svg";
import icon9 from "../assets/images/icons/icon9.svg";
import icon10 from "../assets/images/icons/icon10.svg";
import icon11 from "../assets/images/icons/icon11.svg";
import icon12 from "../assets/images/icons/icon12.svg";
import icon13 from "../assets/images/icons/icon13.svg";
import icon14 from "../assets/images/icons/icon14.svg";
import icon15 from "../assets/images/icons/icon15.svg";
import icon16 from "../assets/images/icons/icon16.svg";
import icon17 from "../assets/images/icons/icon17.svg";
import icon18 from "../assets/images/icons/icon18.svg";
import icon19 from "../assets/images/icons/icon19.svg";
import icon20 from "../assets/images/icons/icon20.svg";
import icon21 from "../assets/images/icons/icon21.svg";
import icon22 from "../assets/images/icons/icon22.svg";
import file1 from "../assets/images/icons/arrow_accordion.svg";
import web from "../assets/images/cases/web.png";
import log_case from "../assets/images/cases/logistic.png";
import sklad_case from "../assets/images/cases/sklad.png";
import smc_case from "../assets/images/cases/smc.png";
import opt_case from "../assets/images/cases/opt.png";
import labomet from "../assets/images/logo/labomet.png";
import bstock from "../assets/images/logo/bstock.svg";
import panocam from "../assets/images/logo/panocam.svg";
import logistic from "../assets/images/logo/logistik.png";
import tehnocorp from "../assets/images/logo/tehnocorp__logo.png";
import scbchm from "../assets/images/logo/skbchm.svg";
import optmarket from "../assets/images/cases/optmarket.png";
import smccontrol from "../assets/images/cases/smccontrol.png";
import logistika from "../assets/images/cases/logistika.png";
import terminal from "../assets/images/cases/terminal.png";
import sklad2 from "../assets/images/cases/sklad2.png";
import tehnocorp2 from "../assets/images/cases/tehnocorp.png";
import erp from "../assets/images/cases/erp.png";
import { text, title } from "framer-motion/client";
export const topBlocks = [
  {
    title: "60+",
    text: "Сотрудников",
    class: "topBox",
  },
  {
    title: "323",
    text: "Проекта",
  },
  {
    title: "50+",
    text: "Заказчиков",
  },
  {
    title: "8",
    text: "Лет опыта",
  },
  {
    title: "98+",
    text: "Успешных сайтов",
  },
];
export const headers = [
  {
    header: "Преимущества",
  },
  {
    header: "Направления деятельности",
  },
  {
    header: "Наши партнёры",
  },
  {
    header: "О нас",
  },
  {
    header: "Наши ценности",
  },
  {
    header: "Прайс-лист",
  },
  {
    header: "Реализованные проекты",
  },
  {
    header: "Перечень видов экономической деятельности",
  },
];

export const menuLinks = [
  {
    id: 1,
    src: "/",
    text: "Главная",
    dropdown: false,
  },
  {
    id: 2,
    src: "/",
    text: "Услуги",
    dropdown: true,
  },
  {
    id: 3,
    src: "/cases",
    text: "Кейсы",
    dropdown: false,
  },
  {
    id: 4,
    src: "/team",
    text: "Наша команда",
    dropdown: false,
  },
];
export const headersPrice = [
  {
    header: "Разработка одностраничного сайта",
  },
  {
    header: "Разработка корпоративных сайтов",
  },
  {
    header: "Разработка интернет-магазина",
  },
  {
    header: "Дополнительные услуги",
  },
  {
    header: "Для всех тарифных планов включено",
  },
];
export const contentProfit = [
  {
    src: icon1,
    description:
      "Служба поддержки работает 24/7. Мы обеспечиваем всестороннее сопровождение клиента",
  },
  {
    src: icon2,
    description:
      "С помощью HelpDesk клиент сам сможет убедиться в своевременном выполнении всех заявок",
  },
  {
    src: icon3,
    description:
      "Наша команда профессионалов поможет Вам создать оптимальные решения для Вашего бизнеса",
  },
  {
    src: icon4,
    description:
      "В работе используются высококлассные системы защиты и мониторинга IT-систем",
  },
  {
    class: "contentBox",
  },
];
export const contentStek = [
  {
    title: "Мобильная разработка",
    description:
      "Проектирование и создание удобных, функциональных решений для iOS и Android, которые помогают бизнесу быть ближе к клиенту.",
  },
  {
    title: "Веб-разработка",
    description:
      "Создание сайтов, сервисов и платформ, которые работают быстро, удобно и эффективно на любых устройствах",
  },
  {
    title: "Автоматизация логистики",
    description:
      "Внедрение цифровых решений для управления доставкой, складом и маршрутами, чтобы сократить издержки и повысить эффективность",
  },
  {
    title: "Автоматизация склада",
    description:
      "Внедрение цифровых решений для учёта, хранения и перемещения товаров, чтобы сократить ошибки и ускорить процессы",
  },
  {
    title: "Разработка программного обеспечения",
    description:
      "Создание цифровых решений под задачи вашего бизнеса: от десктопных систем до облачных платформ",
  },
  {
    class: "contentBox2",
  },
];
export const Banners = [
  {
    title: (
      <>
        Разрабатываем <span className="purple">ИТ-продукты</span>, которые
        упрощают жизнь и ускоряют рост бизнеса
      </>
    ),
    text: "Разработка ПО, web и мобильных решений — от идеи до запуска. Надёжно. Масштабируемо. Эффективно.",
  },
  {
    title: (
      <>
        Проектируем, разрабатываем, обслуживаем технологичные{" "}
        <span className="purple">веб-системы</span>
      </>
    ),
    text: "",
  },
  {
    title: (
      <>
        Разрабатываем и внедряем надежные{" "}
        <span className="purple">мобильные приложения</span>
      </>
    ),
  },
  {
    title: (
      <>
        Разработка устойчивых и эффективных приложений для{" "}
        <span className="purple">автоматизации логистики</span>
      </>
    ),
  },
  {
    title: (
      <>
        Повышение эффективности логических операций с помощью{" "}
        <span className="purple">автоматизации склада</span>
      </>
    ),
  },
  {
    title: (
      <>
        Разработка программного обеспечения.{" "}
        <span className="purple">Внедрение электронной коммерции</span>
      </>
    ),
  },
  {
    title: (
      <>
        Наши <span className="purple">кейсы</span>
      </>
    ),
  },
  {
    title: (
      <>
        Команда <span className="purple">AitiGuru</span> - ключ к Вашему успеху
      </>
    ),
  },
  {
    title: (
      <>
        Заполните <span className="purple">бриф</span> и мы свяжемся с Вами
      </>
    ),
  },
];
export const partners = [
  {
    imageUrl: labomet,
  },
  {
    imageUrl: bstock,
  },
  {
    imageUrl: logistic,
  },
  {
    imageUrl: panocam,
  },
  {
    imageUrl: tehnocorp,
  },
  {
    imageUrl: scbchm,
  },
];
export const webdev = [
  {
    title:
      "Система электронной торговли для работы с розничными каналами продаж",
    text: "Partner Terminal - это комплекс программных решений и технологий, которая помогает оптимизировать процессы управления продажами, маркетингом, аналитикой и коммуникациями с клиентами, виртуальная витрина товаров, расширяющая номенклатуру торговой точки.",
    listTitle: "Задачи",
    src: web,
    list: (
      <>
        <li>Создание удобного интерфейса для пользователей</li>
        <li>Разработка системы купли-продажи</li>
        <li>Настраиваемая ценовая политика</li>
        <li>
          Внедрение аналитики и статистики для отслеживания эффективности продаж
        </li>
      </>
    ),
  },
  {
    title: "Мобильное приложение для экспедиторов",
    text: "“Моя логистика” оказывает услуги ответственного хранения, включающегов себя все операции по складской обработке, погрузо-разгрузочные работы, а также передачи по логистической цепочке по организациям по Москве, Московской области и Центрально Федеральному Округу.",
    listTitle: "Задачи",
    src: log_case,
    list: (
      <>
        <li>Создание удобного интерфейса для экспедиторов</li>
        <li>Возможность создания маршрутов и заданий</li>
        <li>Ведение учета и контроля работы сотрудников</li>
        <li>Уведомление о статусе выполнения работ</li>
      </>
    ),
    btnText: "Платформа: Android",
  },
  {
    title: "Мобильное приложение для склада",
    text: "“Моя логистика” оказывает услуги ответственного хранения, включающегов себя все операции по складской обработке, погрузо-разгрузочные работы, а также передачи по логистической цепочке по организациям по Москве, Московской области и Центрально Федеральному Округу.",
    listTitle: "Задачи",
    src: sklad_case,
    list: (
      <>
        <li>Автоматизация работы со складской продукцией</li>
        <li>Сканирование товаров через смартфон с использованием штрихкодов</li>
        <li>Формирование статистики по складскому товарообороту</li>
        <li>Упрощение работы со складскими товарами</li>
      </>
    ),
    btnText: "Платформа: Android",
  },
  {
    title: "Система для контроля задач и управления бизнес-процессами",
    text: "SMControl - это специальная система для управления бизнес процессами, автоматизции задач внутри компании, и эффективного решения вопросов, связанных с деятельностью компании",
    listTitle: "Задачи",
    src: smc_case,
    list: (
      <>
        <li>Ведение учета, контроля и другой деятельности компании</li>
        <li>Упрощение документооборота между сотрудниками и партнёрами</li>
        <li>Безопасность хранения информации</li>
        <li>Улучшение качества обслуживания клиентов</li>
      </>
    ),
    btnText: "Платформа: IOS",
  },
  {
    title: "Мобильное приложение для управления оптовой торговлей Opt Market",
    text: "ПО зарегистрировано в Реестре программного обеспечения (реестровая запись №21609 от 20.02.2024г). Регистрация произведена на основании поручения Министерства цифрового развития, связи и массовых коммуникаций Российской Федерации от 20.02.2024 по протоколу заседания экспертного совета от 08.02.2024 №48пр",
    listTitle: "Задачи",
    src: opt_case,
    list: (
      <>
        <li>Просмотр каталога товаров</li>
        <li>Формирование корзины товаров</li>
        <li>Просмотр “Избранного” из корзины товаров</li>
        <li>Оформление заказов</li>
        <li>Просмотр профиля пользователя</li>
        <li>Отслеживание статуса выполнения заказов</li>
      </>
    ),
    btnText: "Платформа: Android",
  },
];
export const topCases = [
  {
    text: "Мобильная разработка",
    class: "topBoxCases",
  },
  {
    text: "Веб-разработка",
  },
  {
    text: "Автоматизация логистики",
  },
  {
    text: "Автоматизация склада",
  },
  {
    text: "Электронная коммерция",
  },
];

export const teamBlocks = [
  {
    src: icon1,
    description:
      "Основное направление нашей компании - оптимизация бизнес процессов за счет эффективных и практичных мобильных приложений и веб-сайтов и их последующее техническое сопровождение",
  },
  {
    src: icon1,
    description:
      "Наше главное преимущество — внимание к качеству и индивидуальному подходу. Каждому клиенту мы предоставляем менеджера для сопровождения проекта и адаптации сервиса под задачи бизнеса",
  },
  {
    src: icon1,
    description:
      "Благодаря разработке и внедрению собственных уникальных методов в сфере IT инфраструктуры, мы всегда добиваемся отличных результатов",
  },
];
export const textBlocks = [
  {
    title: "Айти Гуру",
    text: "Мы предоставляем компаниям надёжные и масштабируемые ИТ-решения, ориентированные на производительность и устойчивость. С начала сотрудничества мы погружаемся в архитектуру систем, процессы и цели бизнеса для точной настройки сервисов.",
    class: "textBtns",
  },
  {
    title: "Наша команда нужна Вам, если",
    text: "Вы ищете надёжного партнёра со знаниями в электронной коммерции, умением справляться с высокой загрузкой на веб-сайт и навыком работы с несколькими задачами одновременно",
    class: "d-none",
  },
  {
    title: "Узнали себя?",
    text: "Откликайтесь на интересующие Вас вакансии и станьте частью нашего коллектива!",
    btnTitle: "Стань частью команды",
  },
];
export const cardsData = [
  {
    id: 1,
    class: "card card-primary",
    src: icon5,
    text: "Основное направление нашей компании - оптимизация бизнес процессов за счет эффективных и практичных мобильных приложений и веб-сайтов и их последующее техническое сопровождение",
  },
  {
    id: 2,
    src: icon6,
    class: "card card-primary",
    text: "Наше главное преимущество — внимание к качеству и индивидуальному подходу. Каждому клиенту мы предоставляем менеджера для сопровождения проекта и адаптации сервиса под задачи бизнеса",
  },
  {
    id: 3,
    src: icon7,
    class: "card card-primary",
    text: "Благодаря разработке и внедрению собственных уникальных методов в сфере IT инфраструктуры, мы всегда добиваемся отличных результатов",
  },
];
export const cardsData2 = [
  {
    id: 1,
    src: icon8,
    class: "card card-secondary",
    title: "Корпоративная ответственность",
    text: "Мы стремимся не только зарабатывать деньги, но и оказывать положительное влияние на мир вокруг себя, стремясь донести правильные ценности и принципы до всех сотрудников компании",
  },
  {
    id: 2,
    src: icon9,
    class: "card card-secondary",
    title: "Саморазвитие и карьера",
    text: "В сотрудниках мы высоко ценим постоянное стремление к новым знаниям и непрерывное приобретение новых навыков",
  },
  {
    id: 3,
    src: icon10,
    class: "card card-secondary",
    title: "Положительное отношение к жизни",
    text: "Позитивный настрой позволяет преодолевать множество трудностей и достигать успехов, что мы определенно ценим в наших сотрудниках",
  },
  {
    id: 4,
    src: icon11,
    class: "card card-secondary",
    title: "Ориентация на потребности клиента",
    text: "Наша главная задача - соответствовать требованиям клиента и оправдать его ожидания, показывая только лучшие результаты",
  },
];
export const cardsData3 = [
  {
    id: 1,
    src: icon12,
    class: "card card2",
    text: "Вам требуется команда опытных специалистов на платформе 1С-Битрикс для интеграции веб-решений с различными внутренними системами учёта",
  },
  {
    id: 2,
    src: icon12,
    class: "card card2",
    text: "Вы ищете надёжного партнёра со знаниями в электронной коммерции, умением справляться с высокой загрузкой на веб-сайт и навыком работы с несколькими задачами одновременно",
  },
];
export const cardsData4 = [
  {
    id: 1,
    src: icon13,
    class: "card card3",
    text: "Служба поддержки",
  },
  {
    id: 2,
    src: icon14,
    class: "card card3",
    text: "Размещение сайта на нашем сервере",
  },
  {
    id: 3,
    src: icon15,
    class: "card card3",
    text: "Резервное копирование",
  },
  {
    id: 4,
    src: icon16,
    class: "card card3",
    text: "Защита от вирусов",
  },
];
export const cardsData5 = [
  {
    id: 1,
    src: icon17,
    class: "card card2",
    text: "Собственные мобильные приложения создаются на языке программирования и фреймворках владельца платформы и запускаются непосредственно в операционной системе устройства, такой как iOS или Android",
  },
  {
    id: 2,
    class: "card card2",
    src: icon16,
    text: "В работе используются высококлассные системы защиты и мониторинга IT-систем",
  },
];
export const cardsData6 = [
  {
    id: 1,
    class: "card card4",
    text: "Эффективное управление сотнями заказов, отправок и потоков данных",
  },
  {
    id: 2,
    class: "card card4",
    text: "Устойчивость к высоким нагрузкам",
  },
  {
    id: 3,
    class: "card card4",
    text: "Бесперебойная работа приложения вне зависимости от наличия интернета",
  },
];
export const cardsData7 = [
  {
    id: 1,
    src: icon18,
    class: "card card5",
    text: "В автоматизированном режиме составлять отчеты о нештатных ситуациях",
  },
  {
    id: 2,
    src: icon19,
    class: "card card5",
    text: "Отслеживать движения груза в реальном времени",
  },
  {
    id: 3,
    src: icon20,
    class: "card card5",
    text: "Получать мгновенные отчеты по этапам грузоперевозки",
  },
  {
    id: 4,
    src: icon21,
    class: "card card5",
    text: "Эффективный контроль товарооборота",
  },
  {
    id: 5,
    src: icon22,
    class: "card card5",
    text: "Контроль возвратов и оформление документации с печатью новых этикеток",
  },
];
export const priceData = [
  {
    id: 1,
    title: "Лэндинг Пейдж",
  },
];
export const tablePrice = [
  {
    id: 1,
    name: "Разработка логотипа",
    price: "от 4 000 ₽",
  },
  {
    id: 2,
    name: "Разработка макета сайта в Figma",
    price: "от 15 000 ₽",
  },
  {
    id: 3,
    name: "Копирайт с визуальным оформлением",
    price: "от 5 000 ₽/ стр",
  },
  {
    id: 4,
    name: "Поддержка сайта",
    price: "от 5 000 ₽/ мес",
  },
  {
    id: 5,
    name: "Наполнение сайта “под ключ”",
    price: "от 20 000 ₽",
  },
];
export const accordion = [
  {
    id: 1,
    title: "Продвинутые веб-приложения",
    body: "Мы разработаем дизайн и приложения для веб-сайта вашей организации. Эти приложения хорошо оптимизированы по производительности без ущерба для безопасности.",
  },
  {
    id: 2,
    title: "Веб-порталы",
    body: "Веб-порталы, разработанные нами, построены с использованием уникальных функций и средств автоматизации, которые повышают эффективность процессов организаций и удобство работы пользователей.",
  },
  {
    id: 3,
    title: "Приложения SaaS",
    body: "Программное обеспечение как услуга (SaaS) позволяет компаниям приобретать Ваше программное обеспечение на основе подписки. Наша команда разработает SaaS-приложение, чтобы максимизировать прибыльность Вашей организации.",
  },
  {
    id: 4,
    title: "Корпоративные приложения",
    body: "Корпоративные приложения позволяют компаниям проводить важные бизнес-операции. Мы поможем вашей организации в разработке пользовательского корпоративного приложения. Интеграция корпоративных приложений.",
  },
  {
    id: 5,
    title: "Модернизация приложений",
    body: "Если Ваш продукт использует устаревшее программное обеспечение и нуждается в обновлении, AITI Guru выполнит полный рефакторинг кода. Это позволит ему быть более быстрым и настраиваемым при попытке использования или обновления программы.",
  },
  {
    id: 6,
    title: "Приложения для электронной коммерции",
    body: "Мы разработаем приложение для электронной коммерции для организаций, желающих продавать свои товары онлайн. Эти приложения позволят компаниям принимать платежи и обрабатывать каждую часть онлайн-торговли. Рентабельность инвестиций в приложения электронной коммерции.",
  },
  {
    id: 7,
    title: "Облачные приложения",
    body: "Наша команда создаёт облачные приложения, доступные через браузер. Они работают на серверах и предлагают функции обычных приложений с дополнительными преимуществами.",
  },
  {
    id: 8,
    title: "Реинжиниринг приложений",
    body: "Наши разработчики программного обеспечения на заказ стремятся устранять ошибки и неполадки со всеми типами программных решений и приложений. Мы будем работать над тем, чтобы программное обеспечение Вашей организации работало без проблем",
  },
  {
    id: 9,
    title: "Пользовательское программное обеспечение CRM",
    body: "Наши разработчики программного обеспечения на заказ стремятся устранять ошибки и неполадки со всеми типами программных решений и приложений. Мы будем работать над тем, чтобы программное обеспечение Вашей организации работало без проблем",
  },
  {
    id: 10,
    title: "Пользовательское программное обеспечение ERP",
    body: "Разрабатываемые нами индивидуальные программные решения ERP эффективно консолидируют данные и оптимизируют процессы с помощью передовых средств автоматизации и интеграции. Консолидация пользовательского программного обеспечения ERP",
  },
  {
    id: 11,
    title: "Пользовательское программное обеспечение для аудита",
    body: "Предприятия, приобретающие программное обеспечение для аудита на заказ, могут повысить эффективность за счет автоматизации процессов, связанных с аудитом.",
  },
  {
    id: 12,
    title: "Разработка API",
    body: "API, разработанные нами, предоставляют предприятиям возможность автоматизировать тестирование для проверки производительности приложений, способны интегрироваться с несколькими приложениями и системами и могут быть адаптированы к новым процессам и программному обеспечению. Улучшение разработки API.",
  },
  {
    id: 13,
    title: "Системная интеграция. 1C",
    body: "Мы способны интегрировать системы и приложения, которые занимаются бухгалтерским учетом, управлением взаимоотношениями с клиентами, управлением контентом, планированием корпоративных ресурсов и отчетностью.",
  },
  {
    id: 14,
    title: "Устаревшие системы",
    body: "Мы обладаем большим опытом работы с целым рядом технологий и будем работать над созданием вашего приложения с использованием устаревшего программного обеспечения.",
  },
];
export const accordion2 = [
  {
    id: 1,
    title: "Скачать руководство пользователя",
    link: "Скачать руководство пользователя",
    download: file1,
  },
  {
    id: 2,
    title:
      "Скачать описание процессов, обеспечивающих поддержание жизненного цикла",
    link: "Скачать описание процессов, обеспечивающих поддержание жизненного цикла",
  },
  {
    id: 3,
    title: "Скачать функциональные характеристики",
    link: "Скачать функциональные характеристики",
  },
];
export const caseBlockItem = [
  {
    id: 1,
    src: optmarket,
    textTitle: "Мобильное приложение для управления оптовой торговлей ",
    title: "Opt Market",
    tag: [
      "Просмотр каталога товаров",
      "Формирование корзины товаров",
      "Просмотр “Избранного” из корзины товаров",
      "Оформление заказов",
      "Просмотр профиля пользователя",
      "Отслеживание статуса выполнения заказов",
    ],
    textDescription:
      "ПО зарегистрировано в Реестре программного обеспечения (реестровая запись №21609 от 20.02.2024г). Регистрация произведена на основании поручения Министерства цифрового развития, связи и массовых коммуникаций Российской Федерации от 20.02.2024 по протоколу заседания экспертного совета от 08.02.2024 №48пр",
    links: [
      { id: "1", textLink: "Скачать руководство пользователя", hrefLink: "#" },
      {
        id: "2",
        textLink:
          "Скачать описание процессов, обеспечивающих поддержание жизненного цикла",
        hrefLink: "#",
      },
      {
        id: "3",
        textLink: "Скачать функциональные характеристики",
        hrefLink: "#",
      },
    ],
  },
  {
    id: 2,
    src: smccontrol,
    textTitle:
      "Мобильное приложение для контроля задач и управления бизнес-процессами",
    title: "SMControl",
    tag: [
      "Ведение учета, контроля и другой деятельности компании",
      "Упрощение документооборота между сотрудниками и партнёрами",
      "Безопасность хранения информации",
      "Улучшение качества обслуживания клиентов",
    ],
    links: [
      {
        id: 1,
        textLink: "Подробнее",
        hrefLink: "#",
      },
    ],
  },
  {
    id: 3,
    src: logistika,
    textTitle: "Мобильное приложение для экспедиторов",
    title: "Моя Логистика",
    tag: [
      "Возможность создания маршрутов и заданий",
      "Ведение учета и контроля работы сотрудников",
      "Уведомление о статусе выполнения работ",
    ],
    links: [
      {
        id: 1,
        textLink: "Подробнее",
        hrefLink: "#",
      },
    ],
  },
  {
    id: 4,
    src: sklad2,
    textTitle: "Мобильное приложение для склада",
    tag: [
      "Автоматизация работы со складской продукцией",
      "Сканирование товаров через смартфон с использованием штрихкодов",
      "Формирование статистики по складскому товарообороту",
      "Упрощение работы со складскими товарами",
    ],
    links: [
      {
        id: 1,
        textLink: "Подробнее",
        hrefLink: "#",
      },
    ],
  },
  {
    id: 5,
    src: terminal,
    textTitle:
      "Система электронной торговли для работы с розничными каналами продаж",
    title: "Partner Terminal",
    tag: [
      "Разработка системы купли-продажи",
      "Настраиваемая ценовая политика",
      "Внедрение аналитики и статистики для отслеживания продаж",
    ],
    links: [
      {
        id: 1,
        textLink: "Подробнее",
        hrefLink: "#",
      },
    ],
  },
  {
    id: 6,
    src: tehnocorp2,
    textTitle: "Интернет-магазин",
    title: "TechnoCorp",
    tag: [
      "Корпоративные закупки",
      "Автоматизация бизнес-процессов",
      "Технологичный сервис",
    ],
    links: [
      {
        id: 1,
        textLink: "Подробнее",
        hrefLink: "#",
      },
    ],
  },
  {
    id: 7,
    src: erp,
    textTitle: "ERP система премиум класса для оптовой торговли",
    tag: [
      "ERP для оптовой торговли",
      "Автоматизация бизнеса",
      "Премиальные IT-решения",
      "Управление цепочками поставок",
    ],
    links: [
      {
        id: 1,
        textLink: "Подробнее",
        hrefLink: "#",
      },
    ],
  },
];
